package org.vreo.devicehub.features.device.presentation.deviceList

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.device.AnprDevice

/**
 * Device menu alert item, confirm alert items available
 */
enum class DeviceMenuAlertItem(val value: Int) {
    UNLINK(0),
    DELETE(1)
}

/**
 * Device list state. Represents state of device list screen.
 */
data class DeviceListState(
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isAdmin: Boolean = false,
    val adminViewEnable: Boolean = true,
    val devices: List<AnprDevice> = emptyList(),
    val selectedDevice: AnprDevice? = null,
    val confirmAlertItem: DeviceMenuAlertItem? = null,
)